export enum VariableTypeOptionsEnum {
    all = 'all',
    name = 'name',
    value = 'value',
}
